module.exports = __webpack_public_path__ + "img/DasBlauePony.5610488e.svg";